import React from 'react'
import { useSignalEffect } from '@preact/signals-react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { localize } from 'services/base';
import { msg, openToast, toggleToast, type } from 'signals/modal';

export const NOT_CLOSEABLE_MSG = [
	"TOAST_EVENT_END",
	"TOAST_EVENTOVER",
	"TOAST_EVENT_NOTOPEN",
	"TOAST_NETWORK_ERROR",
	"VISITOR_NOT_ALLOWED",
	"TOAST_SERVER_BUSY",
	"TOAST_WRONG_REGION",
	"TOAST_SERVER_TIMEOUT",
	"TOAST_LOGIN_FAILED",
	"TOAST_TOKEN_EXPIRED",
	"NOT_LOGGED_IN",
	"TOAST_EVENT_CLOSED_AWHILE",
	"?err=41",
	"NO_CHARACTER",
	"EVENT_CLOSED",
	`("ERROR GOP | {'ERROR': 'ERROR_TOKEN'}", 1)`,
	"EVENT_MAINTENANCE",
	"SERVER_ERR",
      "err_default",
      "not_logged_in",
      "maintenance"
];

const ToastNotification = () => {   
      const t = (key) => localize(key);
      useSignalEffect(() => {
            if (openToast.value && msg.value) {
                  if (NOT_CLOSEABLE_MSG.indexOf(msg.value) > -1) {
                        toast.error(t(msg.value), {
                              position: "top-center",
                              autoClose:  false,
                              closeOnClick: false,
                              progress: undefined,
                              theme: "light",
                              closeButton: false,
                        });
                  }
                  else {
                        toast.success(t(msg.value), {
                              position: "top-center",
                              autoClose: 1500,
                              hideProgressBar: true,
                              closeOnClick: true,
                              progress: undefined,
                              theme: "light",
                              onClose: () => toggleToast({ state: false })
                        });
                  }
            }
      }, [])

      return (
            <ToastContainer
                  position="top-center"
                  autoClose={5000}
                  hideProgressBar={false}
                  newestOnTop={false}
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                  theme="light"
                  toastClassName={type.value==='error'?'toast-error':'toast-success'}
            >
            </ToastContainer>
      )
}

export default ToastNotification